"use client";

import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Hotjar from "@hotjar/browser";
import { AxiosError } from "axios";
import mixpanel from "mixpanel-browser";
import identifyHotjarUser from "@lib/hotjar";
class MixpanelService {
  constructor(token) {
    this.shouldRecord = true;
    this.shouldRecord = this.checkShouldRecord();
    mixpanel.init(token, {
      record_sessions_percent: this.shouldRecord ? 25 : 0,
      record_block_selector: "",
      record_mask_text_selector: ".sensitive",
      record_idle_timeout_ms: 900000,
      autocapture: false
    });
  }
  checkShouldRecord() {
    var _window$location;
    if (typeof window === 'undefined') {
      return true;
    }
    const pathname = ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.pathname) || '';
    const shouldSkipRecording = pathname.includes('millasbenefit');
    return !shouldSkipRecording;
  }
  getHotjarSessionId() {
    return identifyHotjarUser();
  }
  trackEvent(eventName, properties, customer) {
    var _window, _properties$error, _properties$error2;
    const isAxiosError = (properties === null || properties === void 0 ? void 0 : properties.error) instanceof AxiosError;
    mixpanel.track(eventName, _objectSpread(_objectSpread({}, properties), {}, {
      customer: !!(customer !== null && customer !== void 0 && customer.is_logged) ? customer : "anonymous",
      location: (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname,
      response_status: isAxiosError ? properties === null || properties === void 0 || (_properties$error = properties.error) === null || _properties$error === void 0 || (_properties$error = _properties$error.response) === null || _properties$error === void 0 ? void 0 : _properties$error.status : undefined,
      response_data: isAxiosError ? properties === null || properties === void 0 || (_properties$error2 = properties.error) === null || _properties$error2 === void 0 || (_properties$error2 = _properties$error2.response) === null || _properties$error2 === void 0 ? void 0 : _properties$error2.data : undefined,
      hotjar_session_id: this.getHotjarSessionId()
      // Send ip address of the user
    }));
  }
  identifyCustomer(customer) {
    if (!(customer !== null && customer !== void 0 && customer.id)) {
      return;
    }
    try {
      mixpanel.identify(customer.id.toString());
      const customerWithDollarPrefix = {};
      Object.keys(customer).forEach(key => {
        const dollarKey = "$".concat(key);
        customerWithDollarPrefix[dollarKey] = customer[key];
      });
      const hotjarSessionId = this.getHotjarSessionId();
      if (hotjarSessionId) {
        Hotjar.identify(hotjarSessionId, {
          email: customer.email,
          name: customer.first_name + " " + customer.last_name
        });
      }
      mixpanel.people.set(customerWithDollarPrefix);
    } catch (error) {
      console.error("Failed to identify customer ".concat(customer.id, ":"), error instanceof Error ? error.message : error);
    }
  }
}
const mixpanelService = new MixpanelService(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN);
export default mixpanelService;